module.exports = __webpack_public_path__ + "img/173.4c857368.jpg";